import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';

import { APWarningNotification } from '../../utils';

import { dialogManagerActiveAtom } from '../../atoms';

import { JSX } from 'react';
import { DialogType } from './types';
import WarningDialog from 'components/shared/WarningDialog/WarningDialog';

const DialogManager = (): JSX.Element | null => {
  const [, setDialogState] = useRecoilState(dialogManagerActiveAtom);
  const { t } = useTranslation('common');
  const dialogState = useRecoilValue<{
    type: DialogType | null;
    open: boolean;
    data?: APWarningNotification;
    onSubmit: () => void;
    onCancel?: () => void;
  }>(dialogManagerActiveAtom);
  const { type, open, data, onSubmit, onCancel } = dialogState;
  const close = () => setDialogState({ ...dialogState, open: false });

  const messageArr = Object.entries({ ...data }).map(([, value]) => value); // Object to array of messages
  const messages = messageArr.map(({ translationKey, messages }) => ({
    title: t(translationKey),
    messages: messages.map(({ meta: { name, time } }) => `${name} - ${time}`)
  })); // Map translation key to localisation message

  if (type === undefined || type === null) return null;

  switch (dialogState.type) {
    case DialogType.WARNING:
      return (
        <WarningDialog
          open={open}
          messages={messages}
          onSubmit={() => {
            onSubmit();
            close();
          }}
          onCancel={() => {
            if (typeof onCancel === 'function') onCancel();
            close();
          }}
        />
      );
    // case DialogType.SOME_OTHER_DIALOG: ...
    default:
      return null;
  }
};

export default DialogManager;
